import { ReportPropsTypes } from "@/app/types/typeConfig/report";
import request from "@/request";

const prefix = "/gw/robot";

export const onReport = async (params: ReportPropsTypes[]) => {
  try {
    return await request.post(`${prefix}/behavior/collect`, params as any);
  } catch (err) {
    return Promise.reject(err);
  }
};
